// 添加样式依赖
import '@/common/css/index.scss';
import './index.scss';

var btn = document.getElementById('routeMall');
btn.onclick = function() {
  window.location.href = './mall.html';
};
